import { computed, makeObservable } from 'mobx';
import { now } from 'mobx-utils';
import { RuntimeClock } from '../RuntimeClock';

export class TickingClockwork {
  readonly parent: RuntimeClock;
  readonly interval: number | 'frame';

  constructor(parent, interval) {
    makeObservable(this);
    this.interval = interval;
    this.parent = parent;
  }

  @computed
  get tickingTime(): number {
    const ticker = now(this.interval); // BUG 05.05.2018 sends inital old value, therefore get time in next line
    return new Date().getTime();
  }
}
